<template>
    <div class=" bg-round bg-fff">
        <div class="container">
            <Bread class="ma-t-30" :list="[{path:'',name:'团队'}]"/>
            <header id="header">
                <div class="flex f-around">
                    <div class="header-li" @click="$router.push('/about/team')">创始人Founder</div>
                    <div class="header-li" @click="$router.push('/merge/curator')">策展团队Curator</div>
                    <!-- <div class="header-li" @click="$router.push('/merge/jury')">评审团Jury</div> -->
                    <div class="header-li header-active" @click="$router.push('/merge/volunteer')">志愿者团队volunteer</div>
                </div>
            </header>
        </div>
        <div class="container  mb-40" id="app">
            <!--<div class="t-center mb-20 ma-tb-20">
                <div class="title">志愿者团队</div>
            </div>-->
            <div class="row line-height-35">
                <div class="row" v-for="(item1,i) in list" :key="i">
                    <div class="col-md-4 t-center img-box" v-for="(item,index) in item1.Item" :key="index">
                        <img :src="item.ImageUrl" alt="">
                        <div class="item-title">{{item.Type}}</div>
                        <div class="item-name">{{item.Name}}</div>
                        <div class="item-text" v-html="item.Summary">
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn">
                <div class="btn-next" @click="toPage('apply')">申请志愿者</div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";
    
    .item-name {
        font-weight: bold;
        font-size: 1.2rem;
    }

    .item-title {
        color: #fb004d;
        font-weight: bold;
        font-size: 1.2rem;
        margin-top: 10px;

    }

    .img-box {
        margin-bottom: 70px;
    }

    .img-box .item-text {
        text-align: left;
        width: 90%;
        margin: 0 auto;
        white-space: pre-line;
    }

    .img-box img {
        width: 80%;
    }

    .btn-next {
        width: 300px;
        height: 50px;
        line-height: 50px;
        color: #fff;
        border-radius: 10px;
        text-align: center;
        background-color: #FB004D;
        margin: 40px auto;
        cursor: pointer;
        display: block;
        text-decoration: none;
    }

    .btn {
        width: 100%;
    }

    .btn a:hover {
        color: #fff;
    }

    .title {
        display: inline-block;
        margin-top: 30px;
        padding-bottom: 6px;
        font-size: 20px;
        color: #666;
        cursor: pointer;
        border-bottom: 3px solid #FB004D;
        font-weight: 600;
        color: #000;
    }
</style>
<script>
    import {getVolunteerQuery} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                list:[],
                footbottom:123,
            };
        },
        created() {
           console.log("开始开发")
            this.loadData()
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            //数据初始化
            loadData(){
                
                getVolunteerQuery().then((res) => {
                    console.log(res);
                    this.list = res.data.Data;
                });
            },
            toPage(url){
                this.$router.push("/merge/"+url);
            }
        },
    };
</script>
